import React from "react";
import "./NotFound.css";

/* eslint-disable react/display-name */
export default () => (
  <div className="NotFound container">
    <div className="NotFound-inner">
      <div>
        <h1 className="NotFound-title">404 – we couldn&apos;t find that page.</h1>
      </div>
    </div>
  </div>
);
